// https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/

const initialOverflowY = document.documentElement.style.overflowY
const initialOverflowX = document.documentElement.style.overflowX

export function lockScroll() {
  document.documentElement.style.overflowY = 'hidden'
  document.documentElement.style.overflowX = 'hidden'
}

export function unlockScroll() {
  document.documentElement.style.overflowY = initialOverflowY
  document.documentElement.style.overflowX = initialOverflowX
}
